// src/config.js
// ** uat 
export const API_ENDPOINT_USER = "https://addpay.net"; 
// export const LIFF_ID = "2006377645-W7nZ89X7"; /// uat
// ** uat 
// https://zooe-ticket.com ** PRODUCTION
// https://addpay.net ** UAT

export const API_ENDPOINT = "https://zooe-ticket.com";
//  export const API_ENDPOINT = "https://addpay.net";
export const LIFF_ID = "2006408059-jkNDeAAD"; /// production
